import { Navigate, Route, Routes } from 'react-router-dom';

import UnregisteredCompania from '../containers/public/unregistered/unregistered-compania';
import Unregistered from '../containers/public/unregistered/unregistered';
import Landing from '../containers/public/landing/Landing';
import InvalidData from '../containers/public/invalid-data/InvalidData';
import HasAssistance from '../containers/public/has-assistance/HasAssistance';
import ExpiredLink from '../containers/public/expired-link/ExpiredLink';
import Cancelled from '../containers/public/cancelled/Cancelled';
import Tracing from '../containers/private/tracing/Tracing';
import Geolocation from '../containers/private/geolocation/Geolocation';
import Contact from '../containers/private/contact/Contact';
import Survey from '../containers/completed/survey/Survey';
import Finish from '../containers/completed/finish/Finish';
import Coverages from '../containers/completed/coverages/Coverages';
import Assistances from '../containers/completed/assistances/Assistances';
import Completed from '../containers/completed/Completed';
import Service from '../containers/common/service/service';
import Confirmation from '../containers/common/confirmation/confirmation';
import CallMeBack from '../containers/common/confirmation/call-me-back/CallMeBack';
import InOurWay from '../containers/common/assistance/on-our-way/InOurWay';
import ModalPrivacy from '../components/modals/policy/modal-privacy/ModalPrivacy';
import { ModalLopdStyles } from '../components/modals/policy/modal-lopd/modal-lopd-styles';
import ModalLegal from '../components/modals/policy/modal-lopd/ModalLopd';

const MobilityRoutes = () => {
  return (
    <Routes>
      <Route path="/" Component={Landing} />
      <Route path="/unregistered" element={<Navigate to="/" />} />
      <Route path="/invalid-data" Component={InvalidData} />
      <Route path="/expired-link" Component={ExpiredLink} />
      <Route path="/cancelled" Component={Cancelled} />
      <Route path="/legal" Component={ModalLegal} />
      <Route path="/lopd" Component={ModalLopdStyles} />
      <Route path="/privacy" Component={ModalPrivacy} />
      <Route path="/contact" Component={Contact} />
      <Route path="/in-our-way" Component={InOurWay} />
      <Route path="/:webParam" Component={UnregisteredCompania} />
      <Route path="/unregistered/:intervention/:identifier" Component={Service} />
      <Route path="/unregistered/:dateFormatInt/:entityCode/:identifier/:language" Component={Unregistered} />
      {/* Rutas para pantalla de finalización */}
      <Route path="/completed/:file/:intervention" Component={Completed} />
      <Route path="/completed/:file/:intervention/assistances" Component={Assistances} />
      <Route path="/completed/done" Component={Finish} />
      <Route path="/completed/:file/:intervention/coverages" Component={Coverages} />
      {/*  */}
      <Route path="/confirmation/:state/:intervention/:identifier/:entityCode" Component={Confirmation} />
      <Route path="/survey/:file/:intervention" Component={Survey} />
      <Route path="/seguimiento/:identifier/:intervention" Component={Tracing} />
      {/* MobilityGeo */}
      <Route path="/aia/:identifier/:file/:companyId" Component={Geolocation} />
      <Route path="/assistance/:intervention/:identifier" element={<Service showMenu />} />
      <Route path="/has-assistance/:reference/:intervention" Component={HasAssistance} />
      <Route path="/callme-back" Component={CallMeBack} />
    </Routes>
  );
};

export default MobilityRoutes;
